import { useCallback, useEffect } from 'react';
import axios from 'axios';
import useToken from '../hooks/useToken';

/**
 * Custom hook to handle fetching and storing the authentication token
 * from the backend using consumer credentials.
 */
const useAuthToken = () => {
    const { token, setToken } = useToken();

    const siteUrl = process.env.REACT_APP_API_SITE_URL;
    const consumerKey = process.env.REACT_APP_API_CONSUMER_KEY;
    const consumerSecret = process.env.REACT_APP_API_CONSUMER_SECRET;

    const getAuthToken = useCallback( async () => {
        if ( !siteUrl || !consumerKey || !consumerSecret ) {
            console.error( 'Environment variables for authentication are not properly set.' );
            return;
        }

        const endpoint = `${siteUrl}/wp-json/api/v2/profile/oauth/token`;

        try {
            const { data } = await axios.post(
                endpoint,
                {
                    consumer_key: consumerKey,
                    consumer_secret: consumerSecret,
                },
                {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                    },
                }
            );

            const { token_type, access_token } = data || {};

            if ( token_type?.toLowerCase() === 'bearer' && access_token ) {
                setToken( access_token );
            } else {
                console.warn( 'Received unexpected token structure:', data );
            }
        } catch (error) {
            console.error( 'Error fetching auth token:', error?.response?.data || error.message );
        }
    }, [siteUrl, consumerKey, consumerSecret, setToken] );

    useEffect( () => {
        getAuthToken();
    }, [getAuthToken] );

    return { token };
};

export default useAuthToken;
